import { get } from "svelte/store";
import {
  activeWorkshop,
  lessons,
  modules,
  currentLessonIndex,
  highestLessonIndex,
} from "./stores.js";
import { setLessonCompletion } from "./firebase.js";

/*

Lesson instance contains
- way of looking up the lesson in the hot $activeWorkshop store:
    - moduleID
    - lessonID (will also let you look up in lessons collection)
- setter for isComplete which
    - runs a firebase update
    - calls updateIsComplete() on the parent module
    - increments $currentLessonIndex (index in flat lesson array)
- getter for isComplete which looks it up in $activeWorkshop

Module instance contains
- moduleID
- isComplete, which is set by an updateIsComplete() function
- updateIsComplete()
    - loops through array of Lesson instances and updates isComplete accordingly
    - refreshes the progress bar (might need to call an external function?)
- lessons: array of Lesson instances

global stores:
- $modules: array of module instances in order
- $lessons: flat array of lesson instances in order
- $currentLessonIndex: current index of $lesson


Stuff to do:
- sort the modules by ordinal
- loop through each module and
    - sort lessons by orindal
    - instantiate each lesson and push it to a local array
    - push that array (destructured) to $lessons
    - at the end of the module, instantiate a Module and push the array of lessons to the lessons property of the module 
    - push that module to $modules


TODO
- add the index to the Lesson class
- Create a highestLessonIndex store that keeps track of the highest lesson index. update this in the setter.

- ProgressBar component:
    - loops through $modules and looks at isComplete for modules and lessons


Maybe there's no isComplete for a module in the database, because that would mean writing twice when you complete the last lesson in the module.
Instead, isComplete could be a property of the Module instance.
*/
class Module {
  constructor(props) {
    this.lessons = props.lessons;
    this.moduleID = props.moduleID;
    this.title = props.title;
    this.isComplete = false;
    this.updateIsComplete();
  }
  updateIsComplete() {
    console.log("updating module isComplete");
    let modIsComplete = true;
    this.lessons.forEach((lesson) => {
      !lesson.isComplete && (modIsComplete = false);
    });
    this.isComplete = modIsComplete;
    // modules.set(modules);
  }
  // TODO see if you can run updateIsComplete from the constructor
}

class Lesson {
  constructor(props) {
    this.lessonID = props.lessonID;
    this.moduleID = props.moduleID;
    this.moduleIndex = props.moduleIndex;
    this.title = props.title;
    this.lessonIndex = props.lessonIndex;
  }

  get isComplete() {
    const ws = get(activeWorkshop);
    return ws.modules[this.moduleID].lessons[this.lessonID].isComplete;
  }

  set isComplete(bool) {
    setLessonCompletion(this, bool)
      .then(() => {
        const thisMod2 = get(modules)[this.moduleIndex];
        thisMod2.updateIsComplete();
        updateHighestLessonIndex();
      })
      .catch((msg) => {
        console.log(msg);
      });
  }
}

export const updateHighestLessonIndex = () => {
  const lessonsLocal = get(lessons);
  let highest = -1;
  lessonsLocal.forEach((lesson, i) => {
    if (lesson.isComplete && i > highest) {
      highest = i;
    }
  });
  highestLessonIndex.set(highest);
};

export const populateLessonsAndModules = (modulesLocal) => {
  // from WorkshopHome, call this function with $activeWorkshop.modules once populated
  // it runs every time anything in the database changes, which includes changing completion status
  // TODO make a version that only updates rather than re initializes everything (just loops through the incoming object, compares values with $lessons, and updates whatever's different)
  let fullLessons = [];

  let fullModules = [];

  const makeSortedArrayWithKeys = (obj) => {
    const arr1 = Object.entries(obj);
    const arr2 = [];
    arr1.forEach((mod) => {
      arr2.push({
        id: mod[0],
        ...mod[1],
      });
    });
    const arr3 = Object.values(arr2).sort((a, b) => {
      return a.ordinal - b.ordinal;
    });
    return arr3;
  };

  let modulesSorted = makeSortedArrayWithKeys(modulesLocal);

  let li = 0;
  modulesSorted.forEach((mod, i) => {
    let lessonsSorted = makeSortedArrayWithKeys(mod.lessons);
    let localLessons = [];
    lessonsSorted.forEach((lesson) => {
      let lessonInst = new Lesson({
        lessonID: lesson.id,
        moduleID: mod.id,
        moduleIndex: i,
        title: lesson.title,
        lessonIndex: li,
      });
      localLessons.push(lessonInst);
      li += 1;
    });
    fullLessons = [...fullLessons, ...localLessons];
    let moduleInst = new Module({
      lessons: localLessons,
      moduleID: mod.id,
      title: mod.title,
    });
    fullModules.push(moduleInst);
  });

  modules.set(fullModules);

  lessons.set(fullLessons);
};
